import { Check } from '@tamagui/lucide-icons';
import { withFeedback } from '@unistocks/shared/utils/haptics/with-feedback';
import { PropsWithRef } from '@unistocks/types';
import { isWeb, ListItem, ListItemProps, Square } from 'tamagui';

export type CheckboxProps = PropsWithRef<
  Omit<ListItemProps, 'title' | 'icon' | 'onPress' | 'onPressIn' | 'onPressOut'> & {
    checked: boolean;
    label?: string;
    onCheckedChange?: (checked: boolean) => void;
  },
  typeof ListItem
>;

export const Checkbox: React.FC<CheckboxProps> = ({
  ref,
  checked,
  onCheckedChange,
  disabled,
  label,
  ...props
}) => {
  const onValueChange = () => {
    if (disabled) {
      return;
    }
    onCheckedChange?.(!checked);
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if ((event.key === ' ' || event.key === 'Spacebar') && !disabled) {
      event.preventDefault();
      onCheckedChange?.(!checked);
    }
  };

  return (
    <ListItem
      ref={ref}
      size={'$5'}
      gap={'$2'}
      px={'$2'}
      tabIndex={0}
      cursor="pointer"
      disabled={disabled}
      title={label}
      focusVisibleStyle={{
        outlineStyle: 'solid',
        outlineWidth: 2,
        outlineColor: '$outlineColor'
      }}
      scaleIcon={1.4}
      icon={({ size }) => (
        <Square bordered bw={'$1'} br={'$2'} size={size} bg={'$background'}>
          {checked ? (
            /* TODO: AnimatePressence */
            <Check testID="checkbox-check" size={size} color={'$unistocks'} />
          ) : null}
        </Square>
      )}
      onPressIn={withFeedback}
      onPress={onValueChange}
      {...(isWeb && { onKeyDown })}
      {...props}
    />
  );
};

Checkbox.displayName = 'Checkbox';
